import { Tag } from "antd";
import { Link } from "react-router-dom";
import routes from "../../utils/routes.js";

const stopRowClick = (e) => e.stopPropagation();

// Ant Design Table dataIndex -> Client entity field. Only entries here are sortable.
const SORT_FIELD_MAP = {
  clientId: "id",
  name: "name",
  email: "email",
  phoneNumber: "phoneNumber",
};

const renderText = (value) => value || "-";

const renderChannel = (value) => {
  if (value === "WEB") return <Tag color="geekblue">Web</Tag>;
  if (value === "APP") return <Tag color="green">Uygulama</Tag>;
  return "-";
};

const renderWallet = (value) =>
  value ? <Tag color="green">Var</Tag> : "-";

const ClientColumns = () => [
  {
    title: "ID",
    dataIndex: "clientId",
    key: "clientId",
    width: 70,
    sorter: true,
    defaultSortOrder: "descend",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "İsim",
    dataIndex: "name",
    key: "name",
    width: 200,
    sorter: true,
    render: renderText,
  },
  {
    title: "Telefon Numarası",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    width: 160,
    sorter: true,
    render: renderText,
  },
  {
    title: "E-posta",
    dataIndex: "email",
    key: "email",
    width: 240,
    sorter: true,
    ellipsis: true,
    render: renderText,
  },
  {
    title: "Telefon Doğrulandı",
    dataIndex: "isPhoneNumberAdded",
    key: "isPhoneNumberAdded",
    width: 160,
    render: (value) =>
      value ? <Tag color="green">Evet</Tag> : <Tag color="red">Hayır</Tag>,
  },
  {
    title: "Kanal",
    dataIndex: "registrationChannel",
    key: "registrationChannel",
    width: 120,
    render: renderChannel,
  },
  {
    title: "Apple Wallet",
    dataIndex: "hasAppleWalletPass",
    key: "hasAppleWalletPass",
    width: 120,
    render: renderWallet,
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    fixed: "right",
    width: 100,
    render: (_, record) => (
      <Link
        to={`${routes.clientDetails}/${record.clientId}`}
        onClick={stopRowClick}
      >
        Detaylar
      </Link>
    ),
  },
];

export { ClientColumns, SORT_FIELD_MAP };
